// src/hooks/useLocalePath.js
import { useTranslation } from 'react-i18next';

export function useLocalePath() {
    const { i18n } = useTranslation();
  
    return (path) => {
        if (!path || path.startsWith('http') || path.startsWith('#')) return path;
        const currentLang = i18n.language || 'fa';
        return `/${currentLang}${path.startsWith('/') ? '' : '/'}${path}`;
    };
}